export const states = [
    { key: 'ISLAMABAD_CAPITAL_TERRITORY', name: 'Islamabad Capital Territory' },
    { key: 'KHYBER-PAKHTUNKHWA', name: 'Khyber-Pakhtunkhwa' },
    { key: 'PUNJAB', name: 'Punjab' },
    { key: 'SINDH', name: 'Sindh' },
    { key: 'AZAD_KASHMIR', name: 'Azad Kashmir' },
    { key: 'BALOCHISTAN', name: 'Balochistan' },
    { key: 'GILGIT_BALTISTAN', name: 'Gilgit-Baltistan' }
]

export const cities = [
    { name: 'Islamabad', key: 'ISLAMABAD', state: 'ISLAMABAD_CAPITAL_TERRITORY' },
    { name: 'Abbottabad', key: 'ABBOTTABAD', state: 'KHYBER-PAKHTUNKHWA' },
    { name: 'Charsada', key: 'CHARSADA', state: 'KHYBER-PAKHTUNKHWA' },
    { name: 'Dera Ismail Khan', key: 'DERA_ISMAIL_KHAN', state: 'KHYBER-PAKHTUNKHWA' },
    { name: 'Kohat', key: 'KOHAT', state: 'KHYBER-PAKHTUNKHWA' },
    { name: 'Mansehra', key: 'MANSEHRA', state: 'KHYBER-PAKHTUNKHWA' },
    { name: 'Mardan', key: 'MARDAN', state: 'KHYBER-PAKHTUNKHWA' },
    { name: 'Mingora', key: 'MINGORA', state: 'KHYBER-PAKHTUNKHWA' },
    { name: 'Nowshera', key: 'NOWSHERA', state: 'KHYBER-PAKHTUNKHWA' },
    { name: 'Peshawar', key: 'PESHAWAR', state: 'KHYBER-PAKHTUNKHWA' },
    { name: 'Swabi', key: 'SWABI', state: 'KHYBER-PAKHTUNKHWA' },
    { name: 'Ahmadpur East', key: 'AHMADPUR_EAST', state: 'PUNJAB' },
    { name: 'Bahawalnagar', key: 'BAHAWALNAGAR', state: 'PUNJAB' },
    { name: 'Bahawalpur', key: 'BAHAWALPUR', state: 'PUNJAB' },
    { name: 'Burewala', key: 'BUREWALA', state: 'PUNJAB' },
    { name: 'Chakwal', key: 'CHAKWAL', state: 'PUNJAB' },
    { name: 'Chichawatni', key: 'CHICHAWATNI', state: 'PUNJAB' },
    { name: 'Chiniot', key: 'CHINIOT', state: 'PUNJAB' },
    { name: 'Chishtian', key: 'CHISHTIAN', state: 'PUNJAB' },
    { name: 'Daska', key: 'DASKA', state: 'PUNJAB' },
    { name: 'Dera Ghazi Khan', key: 'DERA_GHAZI_KHAN', state: 'PUNJAB' },
    { name: 'Faisalabad', key: 'FAISALABAD', state: 'PUNJAB' },
    { name: 'Farookabad', key: 'FAROOKABAD', state: 'PUNJAB' },
    { name: 'Gojra', key: 'GOJRA', state: 'PUNJAB' },
    { name: 'Gujranwala', key: 'GUJRANWALA', state: 'PUNJAB' },
    { name: 'Gujrat', key: 'GUJRAT', state: 'PUNJAB' },
    { name: 'Hafizabad', key: 'HAFIZABAD', state: 'PUNJAB' },
    { name: 'Jaranwala', key: 'JARANWALA', state: 'PUNJAB' },
    { name: 'Jhelum', key: 'JHELUM', state: 'PUNJAB' },
    { name: 'Kamalia', key: 'KAMALIA', state: 'PUNJAB' },
    { name: 'Kamoke', key: 'KAMOKE', state: 'PUNJAB' },
    { name: 'Kasur', key: 'KASUR', state: 'PUNJAB' },
    { name: 'Khanewal', key: 'KHANEWAL', state: 'PUNJAB' },
    { name: 'Khanpur', key: 'KHANPUR', state: 'PUNJAB' },
    { name: 'Khushab', key: 'KHUSHAB', state: 'PUNJAB' },
    { name: 'Kot Adu', key: 'KOT_ADU', state: 'PUNJAB' },
    { name: 'Lahore', key: 'LAHORE', state: 'PUNJAB' },
    { name: 'Mandi Bahauddin', key: 'MANDI_BAHAUDDIN', state: 'PUNJAB' },
    { name: 'Mianwali', key: 'MIANWALI', state: 'PUNJAB' },
    { name: 'Multan', key: 'MULTAN', state: 'PUNJAB' },
    { name: 'Muridke', key: 'MURIDKE', state: 'PUNJAB' },
    { name: 'Muzaffargarh', key: 'MUZAFFARGARH', state: 'PUNJAB' },
    { name: 'Okara', key: 'OKARA', state: 'PUNJAB' },
    { name: 'Pakpattan', key: 'PAKPATTAN', state: 'PUNJAB' },
    { name: 'Rahim Yar Khan', key: 'RAHIM_YAR_KHAN', state: 'PUNJAB' },
    { name: 'Rawalpindi', key: 'RAWALPINDI', state: 'PUNJAB' },
    { name: 'Sadiqabad', key: 'SADIQABAD', state: 'PUNJAB' },
    { name: 'Sahiwal', key: 'SAHIWAL', state: 'PUNJAB' },
    { name: 'Sargodha', key: 'SARGODHA', state: 'PUNJAB' },
    { name: 'Sheikhupura', key: 'SHEIKHUPURA', state: 'PUNJAB' },
    { name: 'Sialkot', key: 'SIALKOT', state: 'PUNJAB' },
    { name: 'Vehari', key: 'VEHARI', state: 'PUNJAB' },
    { name: 'Wah Cantonment', key: 'WAH_CANTONMENT', state: 'PUNJAB' },
    { name: 'Wazirabad', key: 'WAZIRABAD', state: 'PUNJAB' },
    { name: 'Dadu', key: 'DADU', state: 'SINDH' },
    { name: 'Hyderabad', key: 'HYDERABAD', state: 'SINDH' },
    { name: 'Jacobabad', key: 'JACOBABAD', state: 'SINDH' },
    { name: 'Kandhkot', key: 'KANDHKOT', state: 'SINDH' },
    { name: 'Karachi', key: 'KARACHI', state: 'SINDH' },
    { name: 'Khairpur', key: 'KHAIRPUR', state: 'SINDH' },
    { name: 'Larkana', key: 'LARKANA', state: 'SINDH' },
    { name: 'Mirpur Khas', key: 'MIRPUR_KHAS', state: 'SINDH' },
    { name: 'Nawabshah', key: 'NAWABSHAH', state: 'SINDH' },
    { name: 'Shikarpur', key: 'SHIKARPUR', state: 'SINDH' },
    { name: 'Sukkur', key: 'SUKKUR', state: 'SINDH' },
    { name: 'Tando Adam', key: 'TANDO_ADAM', state: 'SINDH' },
    { name: 'Tando Allahyar', key: 'TANDO_ALLAHYAR', state: 'SINDH' },
    { name: 'Athmuqam', key: 'ATHMUQAM', state: 'AZAD_KASHMIR' },
    { name: 'Bagh', key: 'BAGH', state: 'AZAD_KASHMIR' },
    { name: 'Kotli', key: 'KOTLI', state: 'AZAD_KASHMIR' },
    { name: 'Muzaffarabad', key: 'MUZAFFARABAD', state: 'AZAD_KASHMIR' },
    { name: 'New Mirpur', key: 'NEW MIRPUR', state: 'AZAD_KASHMIR' },
    { name: 'Rawala Kot', key: 'RAWALA_KOT', state: 'AZAD_KASHMIR' },
    { name: 'Chaman', key: 'CHAMAN', state: 'BALOCHISTAN' },
    { name: 'Dera Allahyar', key: 'DERA_ALLAHYAR', state: 'BALOCHISTAN' },
    { name: 'Dera Bugti', key: 'DERA_BUGTI', state: 'BALOCHISTAN' },
    { name: 'Dera Murad Jamali', key: 'DERA_MURAD_JAMALI', state: 'BALOCHISTAN' },
    { name: 'Gwadar', key: 'GWADAR', state: 'BALOCHISTAN' },
    { name: 'Kalat', key: 'KALAT', state: 'BALOCHISTAN' },
    { name: 'Khuzdar', key: 'KHUZDAR', state: 'BALOCHISTAN' },
    { name: 'Pishin', key: 'PISHIN', state: 'BALOCHISTAN' },
    { name: 'Qila Saifullah', key: 'QILA_SAIFULLAH', state: 'BALOCHISTAN' },
    { name: 'Quetta', key: 'QUETTA', state: 'BALOCHISTAN' },
    { name: 'Sibi', key: 'SIBI', state: 'BALOCHISTAN' },
    { name: 'Turbat', key: 'TURBAT', state: 'BALOCHISTAN' },
    { name: 'Zhob', key: 'ZHOB', state: 'BALOCHISTAN' },
    { name: 'Ziarat', key: 'ZIARAT', state: 'BALOCHISTAN' },
    { name: 'Aliabad', key: 'ALIABAD', state: 'GILGIT_BALTISTAN' },
    { name: 'Chilas', key: 'CHILAS', state: 'GILGIT_BALTISTAN' },
    { name: 'Dainyor', key: 'DAINYOR', state: 'GILGIT_BALTISTAN' },
    { name: 'Eidgah', key: 'EIDGAH', state: 'GILGIT_BALTISTAN' },
    { name: 'Gakuch', key: 'GAKUCH', state: 'GILGIT_BALTISTAN' },
    { name: 'Gilgit', key: 'GILGIT', state: 'GILGIT_BALTISTAN' }
]